import { getUserPrefs } from './UserPreferences';

export function playSound(src: string, volume: number = 1): void {
  if (getUserPrefs().muteSFX) {
    return;
  }
  const audio = new Audio(src);
  audio.volume = volume;
  audio.play();
}
